import dynamic from "next/dynamic";

import Banner from "./banner/banner";
import LogosSlider from "../common/LogosSlider";
import CoreService from "./core-service/CoreService.js";

// const Banner = dynamic(() => import('./banner/banner'))
const Cta = dynamic(() => import("./cta/cta.js"))
// const LogosSlider = dynamic(() => import('../common/LogosSlider'))
const Contact = dynamic(() => import('./contact-section/contact'))
const NextProject = dynamic(() => import('./next-project/nextProject'))
const Process = dynamic(() => import('./process-section/process'))
const Brand = dynamic(() => import('./brand-section/brand'))
const Enterprices = dynamic(() => import('./enterprices-experiance/enterprices-experiance'))
const FaqSection = dynamic(() => import('../home-new/faq/faq.js'))

function Industry(props) {
    let blocks = props.blocks;
    return (
        <>
            {blocks.length > 0 &&
                <div className="middle-sction industry-middle industries-middel bg-one ">
                    {
                        blocks.map((block, i) => {
                            return (
                                <div key={i}>
                                    {
                                        block.__component === "blocks.home-new-banner" &&
                                        <>

                                            <Banner block={block} />
                                            <LogosSlider />
                                        </>
                                    }
                                    {
                                        block.__component === "blocks.case-study-key-point-blocks" &&
                                        <CoreService block={block} />
                                    }
                                    {
                                        block.__component === "blocks.preference-for-enterprises" &&
                                        <Brand block={block} />
                                    }
                                    {
                                        block.__component === "blocks.stats" &&
                                        <Enterprices data={block} />
                                    }
                                    {
                                        block.__component === "blocks.home-new-development-process" &&
                                        <Process block={block} />
                                    }
                                    {block.__component === "blocks.tech-service-cta" &&
                                        <Cta data={block} />
                                    }
                                    {
                                        block.__component === "blocks.industry-strategies" &&
                                        <NextProject block={block} />
                                    }
                                    {
                                        block.__component === "blocks.faq" &&
                                        <FaqSection data={block} />
                                    }
                                    {
                                        block.__component === "blocks.home-new-form" &&
                                        <Contact data={block} />
                                    }

                                </div>
                            )
                        })
                    }
                </div>
            }
        </>
    );
}

export default Industry;
